import { batch, computed, effect, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

export const adminSkuSavingData = signal([])
export const isLoadingAdminSkuViewMapping = signal(false)
export const adminSkuRowViewedMappings = signal({})
export const adminSkuFormData = signal({})
export const adminSkuFormErrors = signal({})
export const adminSkuReadyToLunchSkuForm = signal([])
export const isReloadAdminSkuData = signal(false)
export const adminSkuSelectedRows = signal([])
export const adminSkuModalData = signal({})
export const adminSkuModalErrors = signal({})
export const isOpenModalAdminSku = signal(false)
export const isMerged = signal(false)

// Computed
export const isOpenDrawerAdminSku = computed(() => !isEmpty(adminSkuFormData.value))
export const adminSkuDrawerTitle = computed(()=> {
    if (!isOpenDrawerAdminSku.value)
        return ""
    if (adminSkuFormData.value.skuID !== null)
        return `Update ${adminSkuFormData.value.oldName}`
})
export const disabledAdminSkuForm = computed(() => !isEmpty(Object.fromEntries(
    Object.entries(adminSkuFormErrors.value).filter(([_, value]) => !!value)
)))
export const disabledAdminSkuModal = computed(() => !isEmpty(Object.fromEntries(
    Object.entries(adminSkuModalErrors.value).filter(([_, value]) => !!value)
)))

// Effects
effect(() => {
    if (!isOpenDrawerAdminSku.value && disabledAdminSkuForm.value)
        adminSkuFormErrors.value = {}
})

// Functions
export const clearAdminSkusSignals = () => batch(() => {
    adminSkuSavingData.value = []
    isLoadingAdminSkuViewMapping.value = false
    adminSkuRowViewedMappings.value = {}
    adminSkuFormData.value = {}
    adminSkuFormErrors.value = {}
    adminSkuReadyToLunchSkuForm.value = []
    adminSkuSelectedRows.value = []
    adminSkuModalData.value = {}
    adminSkuModalErrors.value = {}
    isOpenModalAdminSku.value = false
})